module.exports = __webpack_public_path__ + "img/SMChatlogo2PC.29efcc88.png";